import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {filter, switchMap, takeUntil, tap} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';

import {UserService} from '../../api/user.service';
import {GLOBAL} from '../../shared/global';
import {User, UserFactory} from '../../shared/model/user.entity';

@Component({
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss'],
})
export class UpdatePasswordComponent implements OnInit, OnDestroy {
  private user: User = GLOBAL.currentUser;

  private init$ = new Subject();
  private destroy$ = new Subject();

  constructor(private userService: UserService, private router: Router) {
    this.init$
      .pipe(
        filter(() => !GLOBAL.currentUser || !GLOBAL.currentUser.id),
        switchMap(() => this.getUser()),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  ngOnInit() {
    this.init$.next();
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  private getUser() {
    return this.userService.getUserByEmail(this.user.email).pipe(
      tap(
        ({status, data}: {status: number; data: any}) => {
          if (status === 200) {
            this.user = UserFactory.createUser(data);
            GLOBAL.currentUser.id = this.user.id;
          } else {
            this.router.navigate(['/authenticate']);
          }
        },
        (err) => this.router.navigate(['/authenticate'])
      )
    );
  }

  onSubmit() {
    this.router.navigate(['/dashboard']);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/update-password/update-password.component.ts